import { ILogItem, ICommonProperties } from './types'

const namespaceRegex = /^[A-Z][A-Za-z0-9]*(\.[A-Z][A-Za-z0-9]*)*$/
const nameRegex = /^[A-Z][A-Za-z0-9]*$/

export type Tests<T> = [keyof T, RegExp][]

const propertyTests: Tests<ICommonProperties> = [
  ['EventName', namespaceRegex],
  ['Namespace', namespaceRegex],
  ['ShortEventName', nameRegex],
]

const logItemTests: Tests<ILogItem> = [
  ['Namespace', namespaceRegex],
  ['ShortEventName', nameRegex],
]

export function assertValidNamespace (namespace: string) {
  if (!namespaceRegex.test(namespace)) {
    throw new Error(`namespace "${namespace}" does not match pattern ${namespaceRegex.toString()}`)
  }
}

export function assertValidName (name: string) {
  if (!nameRegex.test(name)) {
    throw new Error(`name "${name}" does not patch pattern ${nameRegex.toString()}`)
  }
}

export function assertValidProperty<T> (properties: T, key: keyof T, pattern: RegExp) {
  const value = `${properties[key]}`
  if (!pattern.test(value)) {
    throw new Error(`${key} "${value}" does not match pattern ${pattern.toString()}`)
  }
}

export function assertValidProperties<T> (properties: T, tests: Tests<T>) {
  tests.forEach(([key, pattern]) => assertValidProperty<T>(properties, key, pattern))
}

export function assertValidCommonProperties (properties: ICommonProperties) {
  assertValidProperties<ICommonProperties>(properties, propertyTests)
}

export function assertValidLogItem (logItem: ILogItem) {
  assertValidProperties<ILogItem>(logItem, logItemTests)
}